export default function headSection() {
  //헤더
  return (
    <h1>
      {/**모바일 */}
      <div className="typo-32 text-level-1 desktop:hidden mt-13 pb-7 font-black">
        <div className="">
          <div className="pb-2">한 달안에 취득하는</div>
          <div className="pb-4">
            1종
            <span className="text-main-orange"> · </span>
            2종
            <span className="text-main-orange"> · </span>대형 운전면허!
          </div>
        </div>
        <div className="typo-20 leading-snug font-bold">
          운전학원 대비 절반가격,
          <br />
          안전하고 신속한 면허취득!
        </div>
      </div>

      {/**웹 */}
      <div className="typo-50 text-level-1 web-w desktop:block mx-auto mt-20 hidden pb-10">
        <div className="pb-5">
          <span className="font-semibold">한 달안에 취득하는 </span>
          <span className="font-black">
            1종
            <span className="text-main-orange tracking-tight"> · </span>
            2종
            <span className="text-main-orange tracking-tight"> · </span>대형
            운전면허!
          </span>
        </div>
        <div className="typo-32 text-level-3 font-bold">
          운전학원 대비 절반가격, 안전하고 신속한 면허취득!
        </div>
      </div>
    </h1>
  );
}
